export default {"src":"/_next/static/media/sharif.aa806c74.svg","height":37,"width":166,"blurWidth":0,"blurHeight":0};